export const FETCH_ALERT_PREFERENCES = 'FETCH_ALERT_PREFERENCES';
export const FETCH_ALERT_PREFERENCES_DONE = 'FETCH_ALERT_PREFERENCES_DONE';
export const FETCH_ALERT_PREFERENCES_ERROR = 'FETCH_ALERT_PREFERENCES_ERROR';
export const SET_ALERT_PREFERENCES = 'SET_ALERT_PREFERENCES';
export const SET_ALERT_PREFERENCES_DONE = 'SET_ALERT_PREFERENCES_DONE';
export const SET_ALERT_PREFERENCES_ERROR = 'SET_ALERT_PREFERENCES_ERROR';
export const RESET_ALERT_PREFERENCES = 'RESET_ALERT_PREFERENCES';
export const SET_ALERT_CHANNEL = 'SET_ALERT_CHANNEL';
export const SET_ALERT_CHANNEL_DONE = 'SET_ALERT_CHANNEL_DONE';
export const SET_ALERT_CHANNEL_ERROR = 'SET_ALERT_CHANNEL_ERROR';
//# sourceMappingURL=actionTypes.js.map